module.exports = __webpack_public_path__ + "img/lead-03e.5b8302a3.png";